import { type ActionIconProps, type MantineTheme } from "@mantine/core";
import { useMantineTheme } from "@mantine/core";
import StarToggle, { type StarSize, type StarToggleProps } from "./StarToggle";

type OverlayStarToggleProps = Omit<StarToggleProps, "color"> & {
  size?: StarSize;
  buttonSize?: string | number;
  withGlass?: boolean;
  color?: string;
};

function OverlayStarToggle(props: OverlayStarToggleProps) {
  const {
    isSelected,
    onToggle,
    disabled,
    size = "sm",
    buttonSize,
    withGlass = false,
    color = "white",
    w,
    h,
    radius = "md",
    style,
    styles,
    ...rest
  } = props;
  const theme = useMantineTheme();
  const resolvedButtonSize = buttonSize ?? theme.spacing["2xl"];
  const mergedStyles =
    typeof styles === "function"
      ? (theme: MantineTheme, props: ActionIconProps, ctx: unknown) => {
          const resolved = styles(theme, props, ctx);
          return {
            ...resolved,
            root: {
              backgroundColor: "transparent",
              "&:hover": {
                backgroundColor: "transparent",
              },
              ...resolved.root,
            },
          };
        }
      : {
          ...styles,
          root: {
            backgroundColor: "transparent",
            "&:hover": {
              backgroundColor: "transparent",
            },
            ...styles?.root,
          },
        };

  return (
    <StarToggle
      isSelected={isSelected}
      onToggle={onToggle}
      size={size}
      color={color}
      disabled={disabled}
      topicId={props.topicId}
      bg="transparent"
      w={w ?? resolvedButtonSize}
      h={h ?? resolvedButtonSize}
      radius={radius}
      style={{
        backgroundColor: "transparent",
        ...(withGlass
          ? {
              // 🔒 EXCEPTION: Glassmorphism effect not available in standard theme
              backdropFilter: "blur(8px)",
              border: "1px solid rgba(255, 255, 255, 0.0)",
            }
          : null),
        ...style,
      }}
      styles={mergedStyles}
      {...rest}
    />
  );
}

export default OverlayStarToggle;
